import Vue from 'vue';
/**
 * 下拉框懒加载（el-select-loadmore是自定义的指令，使用时前面加v-）
 * date:2023-08-07
 */
Vue.directive('el-select-loadmore', {
    // el:使用自定义指令的元素（下拉框），
    bind(el, binding) {
        // 下拉框下拉的框
        const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        // 增加滚动监听，
        SELECTWRAP_DOM.addEventListener('scroll', function() {
            // scrollHeight:当前所有选项的高度
            // scrollTop:滚动的距离
            // clientHeight:下拉框的高度
            const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
            // 当滚动条滚动到最底下的时候执行接口加载下一页
            if (condition) {
                binding.value();
            }
        });
    }
});
